import React from 'react';

const TestStyle = () => {
  return (
    <>
      <div className="section section--want-test">
        <div className="section__content_data">
          <div className="want-test">
            <div className="want-test__content">
              <div className="want-test__title">
                <div className="title">Want to test it out?</div>
              </div>

              <div className="want-test__text">
                <p>
                  <span className="mobile">Or j</span>
                  <span className="desktop">J</span>ust text
                  <span className="digit">100</span> to
                  <span className="digit">628-444-4421</span> to see an example
                  of what the potential buyer receives when they text your
                  number from a yard sign rider.{' '}
                </p>
                <p>
                  <strong>100% money back guarantee!</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestStyle;
